exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeleteModal-module__wrapper___2sWTQ{display:grid;gap:1rem}.DeleteModal-module__wrapper___2sWTQ img{max-width:200px;margin:0 auto;display:flex;justify-content:center}.DeleteModal-module__wrapper___2sWTQ a{color:#0827e9;cursor:pointer}.DeleteModal-module__wrapper___2sWTQ p{justify-self:start!important}.DeleteModal-module__buttons-wrapper___5Unfg{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:end}", ""]);

// exports
exports.locals = {
	"wrapper": "DeleteModal-module__wrapper___2sWTQ",
	"buttons-wrapper": "DeleteModal-module__buttons-wrapper___5Unfg"
};